// extracted by mini-css-extract-plugin
export default {"clpEligibilityTable":"QJTDOAUmx_BeHjYuCwij","noData-container":"UtNI8vPsxyAkx3FlP99z","table-caption":"IskopQyEN0gC61cRWBTc"};